<tg-row class="summary-page-property-description-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Property description</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-property-description-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyDescription }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit property description</a
        >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-property-description-section__content">
        <span class="summary-page-property-description-section__content-label"
            >Listing title:</span
        >
        {{ listingTitle }}
    </tg-col>
</tg-row>
<property-summary-page-description-field></property-summary-page-description-field>
<tg-row *ngIf="!isDwellingSubcategory">
    <tg-col class="summary-page-property-description-section__content">
        <span class="summary-page-property-description-section__content-label"
            >Viewing Instructions:</span
        ><br />
        <span class="summary-page-property-description-section__content-value">
            {{ viewingInstructions }}
        </span>
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-description-section__content">
        <span class="summary-page-property-description-section__content-label"
            >Amenities in this area:</span
        ><br />
        <span class="summary-page-property-description-section__content-value">
            {{ amenities }}
        </span>
    </tg-col>
</tg-row>
<tg-row>
  <tg-col class="summary-page-property-description-section__content">
        <span class="summary-page-property-description-section__content-label"
        >Agency reference #:</span
        >
      {{ agencyReference }}
  </tg-col>
</tg-row>
